
import React from "react";
import CalendarMobile from "../components/CalendarMobile";
import CircleImageUpload from "../components/CircleImageUpload";
import EmployeeCountDown from "../components/EmployeeCountDown";
import CoffeeChart from "../components/CoffeeChart";
import DonutChart from "../components/DonutChart";
import SmoothLineChart from "../components/LineChart";
import CustomBarChart from "../components/CustomBarChart";
import CustomPieChart from "../components/PieChart";
import DonutChartTwo from "../components/DonutChartTwo";
import CustomAreaChart from "../components/AreaChart";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faUser, faEdit, faEye
} from '@fortawesome/free-solid-svg-icons';

const Home = () =>{
    return(
        <div className="container mt-6">
            <div className="card-header p-0 pb-3 mb-5">
                <h3 class="">Records</h3>
            </div>
            <div className="row">
                <div className="col-lg-3">
                    <div className="card card-box card-primary">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-secondary">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-info">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="card card-box card-warning">
                        <div className="card-body">
                            <div className="row align-irems-center">
                                <div className="col">
                                    <h6>Total Profit</h6>
                                    <p className="h4">$240</p>
                                </div>
                                <div className="col-auto">
                                    <FontAwesomeIcon icon={faUser} className="" />
                                </div>
                            </div>
                            <div className="mt-4">
                                <p className="text-white mb-0 h6">From Previous Month</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Employee</h3>
                        </div>
                        <div className="card-block">
                            <div className="table-responsive">
                                <table className="table table-custom table-bordered-full table-hover">
                                    <tr>
                                        <th>S.N</th>
                                        <th>Name</th>
                                        <th>Designation</th>
                                        <th>Actions</th>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>Rohan Patil</td>
                                        <td>PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>Ravi Shankar</td>
                                        <td>Senior PHP Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>Mukesh Kumar</td>
                                        <td>Magento Developer</td>
                                        <td align="right">
                                            <FontAwesomeIcon icon={faEdit} />
                                            <FontAwesomeIcon icon={faEye} />
                                        </td>
                                    </tr>
                                </table>
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination">
                                        <li className="page-item">
                                            <a className="page-link" href="#" aria-label="Previous">
                                                <span aria-hidden="true">&laquo;</span>
                                            </a>
                                        </li>
                                        <li className="page-item"><a className="page-link" href="#">1</a></li>
                                        <li className="page-item"><a className="page-link" href="#">2</a></li>
                                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                                        <li className="page-item">
                                        <a className="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Accordion</h3>
                        </div>
                        <div className="card-block">
                            <div class="accordion" id="accordionExample2">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoOne" aria-expanded="true" aria-controls="collapsedemoOne">
                                            Accordion Item #1
                                        </button>
                                    </h2>
                                    <div id="collapsedemoOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample2">
                                        <div class="accordion-body">
                                            <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance,
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoTwo" aria-expanded="false" aria-controls="collapsedemoTwo">
                                            Accordion Item #2
                                        </button>
                                    </h2>
                                    <div id="collapsedemoTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample2">
                                        <div class="accordion-body">
                                            <strong>This is the second item's accordion body.</strong> It is hidden by default, until the
                                            collapse plugin adds the appropriate classes that we use to style each element. These classes
                                            control the overall appearance, as well as the showing and hiding via CSS transitions. You can
                                            modify any of this with custom CSS or overriding our default variables. It's also worth noting that
                                            just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit
                                            overflow.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsedemoThree" aria-expanded="false" aria-controls="collapsedemoThree">
                                            Accordion Item #3
                                        </button>
                                    </h2>
                                    <div id="collapsedemoThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample2">
                                        <div class="accordion-body">
                                            <strong>This is the third item's accordion body.</strong> It is hidden by default, until the
                                            collapse plugin adds the appropriate classes that we use to style each element. These classes
                                            control the overall appearance, as well as the showing and hiding via CSS transitions. You can
                                            modify any of this with custom CSS or overriding our default variables. It's also worth noting that
                                            just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit
                                            overflow.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Calendar</h3>
                        </div>
                        <div className="card-block">
                            <CalendarMobile />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="">Icon Timeline</h3>
                        </div>
                        <div className="card-block">
                            <div className="timeline-container">
                                <div className="timeline-line">
                                    {/* Item 1 */}
                                    <div className="timeline-item">
                                        <div className="timeline-badge bg-primary">
                                            <div className="badge-icon text-white">
                                                <FontAwesomeIcon icon={faUser} className="" />
                                            </div>
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="">ALL HANDS MEETING</h6>
                                            <p className="timeline-item-description">Lorem ipsum dolor sit amet, today at 12:00 PM</p>
                                            <p className="timeline-item-time text-primary">12:00 PM</p>
                                        </div>
                                    </div>
                                    {/* Item 2 */}
                                    <div className="timeline-item">
                                        <div className="timeline-badge bg-secondary">
                                            <div className="badge-icon text-white">
                                                <FontAwesomeIcon icon={faUser} className="" />
                                            </div>
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">Project Meeting</h6>
                                            <p className="timeline-item-description">At 1:00 PM</p>
                                            <p className="timeline-item-time text-secondary">1:00 PM</p>
                                        </div>
                                    </div>
                                    {/* Item 3 */}
                                    <div className="timeline-item">
                                        <div className="timeline-badge bg-info">
                                            <div className="badge-icon text-white">
                                                <FontAwesomeIcon icon={faUser} className="" />
                                            </div>
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">Critical Issue</h6>
                                            <p className="timeline-item-description">Needs immediate attention.</p>
                                            <p className="timeline-item-time text-info">2:30 PM</p>
                                        </div>
                                    </div>
                                    {/* Item 4 */}
                                    <div className="timeline-item">
                                        <div className="timeline-badge bg-success">
                                            <div className="badge-icon text-white">
                                                <FontAwesomeIcon icon={faUser} className="" />
                                            </div>
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="timeline-item-title">Brainstorming Session</h6>
                                            <p className="timeline-item-description">Discuss new ideas and solutions.</p>
                                            <p className="timeline-item-time text-success">4:00 PM</p>
                                        </div>
                                    </div>
                                    {/* Item 5 */}
                                    <div className="timeline-item">
                                        <div className="timeline-badge bg-warning">
                                            <div className="badge-icon text-white">
                                                <FontAwesomeIcon icon={faUser} className="" />
                                            </div>
                                        </div>
                                        <div className="timeline-content">
                                            <h6 className="">ALL HANDS MEETING</h6>
                                            <p className="timeline-item-description">Lorem ipsum dolor sit amet, today at 12:00 PM</p>
                                            <p className="timeline-item-time text-warning">12:00 PM</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header">
                            <h3>File Upload</h3>
                        </div>
                        <div className="card-block">
                            <CircleImageUpload />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card" style={{ height: "288px",}}>
                        <div className="card-header">
                            <h3>Count Down</h3>
                        </div>
                        <div className="card-block">
                            <EmployeeCountDown />
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div className="card" style={{ height: "288px",}}>
                        <div className="card-header">
                            <h3>Ribbon</h3>
                        </div>
                        <div className="card-block">
                            <div className="ribbon-container">
                                <div className="ribbon text-white">Ribbon</div>
                                <div className="content">
                                    <div class="row mb-20">
                                        <div class="col-auto">
                                            <img class="img-50 rounded-circle p-0" alt="Profile" src="./profile.jpg" />
                                        </div>
                                        <div class="col">
                                            <h5 class="m-0">Mukesh Kumar</h5>
                                            <span class="m-0 f-12">Magento Developer</span>
                                        </div>
                                    </div>
                                    <p class="f-14 m-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Bar Chart</h3>
                        </div>
                        <div className="card-block">
                            <CoffeeChart />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Donut Chart</h3>
                        </div>
                        <div className="card-block">
                            <DonutChart />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Line Chart</h3>
                        </div>
                        <div className="card-block">
                            <SmoothLineChart />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Bar Chart</h3>
                        </div>
                        <div className="card-block">
                            <CustomBarChart />
                        </div>
                    </div>
                </div>
                {/* <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Pie Chart</h3>
                        </div>
                        <div className="card-block">
                            <CustomPieChart />
                        </div>
                    </div>
                </div> */}
                {/* <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header">
                            <h3>Donut Chart</h3>
                        </div>
                        <div className="card-block">
                            <DonutChartTwo />
                        </div>
                    </div>
                </div> */}
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3>Area Chart</h3>
                        </div>
                        <div className="card-block">
                            <CustomAreaChart />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Home;